"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatSpaceSelection = ChatSpaceSelection;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../../View/Modals/FormContext");
const ChatMembersSelector_1 = require("./ChatMembersSelector");
const chatSpacesService_1 = require("./chatSpacesService");
/**
 * Wybór pokoju Google Chat przy tworzeniu kontraktu ENVI. Zapisuje do pola formularza
 * `_chatSpaceSelection` (jednorazowa instrukcja dla serwera, jak `_milestonesSelection`).
 * Domyślnie „Bez pokoju" — pokój zakłada się świadomie, bo zaprasza prawdziwych ludzi.
 *
 * Oznaczenie nowego kontraktu nadaje serwer przy zapisie, więc dla zakresu „kontrakt"
 * nie da się go podpowiedzieć w formularzu: puste pole nazwy = serwer ułoży
 * `<oznaczenie> <alias albo nazwa>`. Dla zakresu „projekt" podpowiedź jest znana od razu.
 *
 * Renderowany tylko przy dodawaniu kontraktu ENVI.
 */
function ChatSpaceSelection() {
    const { setValue, watch } = (0, FormContext_1.useFormContext)();
    const project = watch("_project");
    const projectOurId = project?.ourId;
    const contractAlias = watch("alias");
    const contractName = watch("name");
    const selection = watch("_chatSpaceSelection") ?? { mode: "none" };
    const persons = watch(ChatMembersSelector_1.CHAT_MEMBERS_FIELD);
    const personIds = persons?.map(person => person.id);
    (0, react_1.useEffect)(() => {
        if (selection.mode === "new" && (selection.personIds ?? []).join() !== (personIds ?? []).join()) {
            setValue("_chatSpaceSelection", { ...selection, personIds }, { shouldValidate: true });
        }
    }, [persons, selection, setValue]);
    // Nazwa wpisana przez użytkownika; null = nie ruszał, pokazujemy podpowiedź.
    const [typedName, setTypedName] = (0, react_1.useState)(null);
    const [spaces, setSpaces] = (0, react_1.useState)(null);
    const [spacesLoading, setSpacesLoading] = (0, react_1.useState)(false);
    const cacheRef = (0, react_1.useRef)(new Map());
    (0, react_1.useEffect)(() => {
        if (!projectOurId) {
            setSpaces(null);
            return;
        }
        if (cacheRef.current.has(projectOurId)) {
            setSpaces(cacheRef.current.get(projectOurId) ?? null);
            return;
        }
        let cancelled = false;
        setSpacesLoading(true);
        (0, chatSpacesService_1.fetchChatSpacesForProject)(projectOurId).then((list) => {
            cacheRef.current.set(projectOurId, list);
            if (cancelled)
                return;
            setSpaces(list);
            setSpacesLoading(false);
        });
        return () => {
            cancelled = true;
        };
    }, [projectOurId]);
    // Lista niedostępna (brak trasy albo błąd) -> wybór „Istniejący pokój" się nie pokazuje.
    const existingAvailable = !spacesLoading && spaces !== null && spaces.length > 0;
    // Opcja „Istniejący pokój" zniknęła (pusta lista, wyczyszczony projekt), a wybrany był ten tryb:
    // wracamy do „Bez pokoju", żeby walidacja nie blokowała zapisu niewidocznym wyborem.
    (0, react_1.useEffect)(() => {
        if (!spacesLoading && !existingAvailable && selection.mode === "existing") {
            setValue("_chatSpaceSelection", { mode: "none" }, { shouldValidate: true });
        }
    }, [spacesLoading, existingAvailable, selection.mode, setValue]);
    const scope = selection.mode === "new" ? selection.scope : "contract";
    function suggestion(forScope) {
        return forScope === "project" ? (0, chatSpacesService_1.suggestChatSpaceName)(project?.ourId, project?.alias, project?.name) : "";
    }
    function write(next) {
        setValue("_chatSpaceSelection", next, { shouldValidate: true });
    }
    function writeNew(nextScope, name) {
        const trimmed = (name ?? "").trim();
        write({
            mode: "new",
            scope: nextScope,
            ...(personIds?.length ? { personIds } : {}),
            displayName: trimmed ? trimmed.slice(0, chatSpacesService_1.CHAT_SPACE_NAME_MAX) : undefined,
        });
    }
    function chooseMode(mode) {
        if (mode === "none")
            return write({ mode: "none" });
        if (mode === "new")
            return writeNew(scope, typedName);
        write({ mode: "existing", chatSpaceId: spaces?.[0]?.id ?? 0 });
    }
    function changeName(value) {
        setTypedName(value);
        writeNew(scope, value);
    }
    const shownName = typedName ?? suggestion(scope);
    const placeholder = scope === "contract"
        ? `Domyślnie: oznaczenie kontraktu (nadane przy zapisie) ${(0, chatSpacesService_1.suggestChatSpaceName)("", contractAlias, contractName)}`.trim()
        : "Nazwa pokoju";
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mt-3", controlId: "_chatSpaceSelection", "data-testid": "chat-space-selection" },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Pok\u00F3j Google Chat"),
        react_1.default.createElement("div", null,
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "radio", inline: true, name: "chatSpaceMode", id: "chatSpaceMode-new", label: "Nowy pok\u00F3j", checked: selection.mode === "new", onChange: () => chooseMode("new") }),
            existingAvailable && (react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "radio", inline: true, name: "chatSpaceMode", id: "chatSpaceMode-existing", label: "Istniej\u0105cy pok\u00F3j", checked: selection.mode === "existing", onChange: () => chooseMode("existing") })),
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "radio", inline: true, name: "chatSpaceMode", id: "chatSpaceMode-none", label: "Bez pokoju", checked: selection.mode === "none", onChange: () => chooseMode("none") })),
        selection.mode === "new" && (react_1.default.createElement("div", { className: "mt-2", "data-testid": "chat-space-new" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "radio", inline: true, name: "chatSpaceScope", id: "chatSpaceScope-contract", label: "Dla kontraktu", checked: scope === "contract", onChange: () => writeNew("contract", typedName) }),
                react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "radio", inline: true, name: "chatSpaceScope", id: "chatSpaceScope-project", label: "Dla projektu", checked: scope === "project", onChange: () => writeNew("project", typedName) })),
            react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "mt-2", htmlFor: "chatSpaceName" }, "Nazwa pokoju"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { id: "chatSpaceName", type: "text", maxLength: chatSpacesService_1.CHAT_SPACE_NAME_MAX, value: shownName, placeholder: placeholder, onChange: (e) => changeName(e.target.value) }),
            react_1.default.createElement(ChatMembersSelector_1.ChatMembersSelector, null),
            react_1.default.createElement("div", { className: "text-muted small mt-1" }, "Pok\u00F3j powstanie po zapisie kontraktu; zaproszeni zostan\u0105 wybrane osoby oraz koordynator, administrator i Ty."))),
        selection.mode === "existing" && (react_1.default.createElement("div", { className: "mt-2", "data-testid": "chat-space-existing" }, spacesLoading ? (react_1.default.createElement("div", { className: "text-muted small d-flex align-items-center gap-1" },
            react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm" }),
            react_1.default.createElement("span", null, "Wczytuj\u0119 pokoje\u2026"))) : (react_1.default.createElement(react_bootstrap_1.Form.Select, { "aria-label": "Istniej\u0105cy pok\u00F3j", value: selection.chatSpaceId, onChange: (e) => write({ mode: "existing", chatSpaceId: Number(e.target.value) }) }, (spaces ?? []).map((space) => (react_1.default.createElement("option", { key: space.id, value: space.id }, space.displayName)))))))));
}
